import { CommonModule } from '@angular/common'
import { Component, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { TourService, IStepOption, TourStepTemplateComponent } from 'ngx-ui-tour-md-menu'
import { MaterialModule } from '../../../material.module'
import { Subject } from 'rxjs'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { Router } from '@angular/router'
import rpToursData from '../../../../assets/rpTours.json'
import { TourGuideService } from '../../services/tour-guide.service'

export interface Tour {
  tourName: string
  steps: IStepOption[]
}

@Component({
    selector: 'restricted-product-tour-guide',
    imports: [TourStepTemplateComponent, CommonModule, MatButtonModule, MaterialModule],
    templateUrl: './tour-guide.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./tour-guide.component.scss']
})
export class TourGuideComponent implements OnDestroy {
  private destroyed$ = new Subject<void>()
  private _showDialog = false

  mainAccountsTourContent: Tour
  mainAccountsTourContentNoAccount: Tour
  accountInfoTourContent: Tour
  createAuthorizationTourContent: Tour

  activateTour = true
  dialogRef: MatDialogRef<any>

  constructor(
    public router: Router,
    private tourService: TourService,
    private dialog: MatDialog,
    private tourGuideService: TourGuideService
  ) {}

  /* istanbul ignore next */
  ngOnDestroy(): void {
    this.destroyed$.next()
    this.destroyed$.complete()
  }

  /* istanbul ignore next */
  @Input()
  get showDialog(): boolean {
    return this._showDialog
  }

  /* istanbul ignore next */
  set showDialog(value: boolean) {
    this._showDialog = value
  }

  /* istanbul ignore next */
  moveToNextStep(): void {
    this.tourService.next()
  }
}
